import { Plugin } from '@nuxt/types';

import { AUTH_FAILED_EVENT, AUTH_READY_EVENT } from '@/constants/authEvents';

const INITIAL_LOADING_ID = 'initial-loading';
const HIDDEN_CLASS_NAME = 'is-hidden';
const FADE_OUT_DURATION_MS = 350;
const FALLBACK_TIMEOUT_MS = 45000;

const hideInitialLoading = (): void => {
  const element = document.getElementById(INITIAL_LOADING_ID);
  if (!element) return;

  element.classList.add(HIDDEN_CLASS_NAME);
  window.setTimeout(() => {
    element.remove();
  }, FADE_OUT_DURATION_MS);
};

const initialLoadingPlugin: Plugin = () => {
  if (typeof window === 'undefined') return;

  let hasHidden = false;
  const hideOnce = () => {
    if (hasHidden) return;
    hasHidden = true;
    window.removeEventListener(AUTH_READY_EVENT, hideOnce);
    window.removeEventListener(AUTH_FAILED_EVENT, hideOnce);
    hideInitialLoading();
  };

  window.addEventListener(AUTH_READY_EVENT, hideOnce);
  window.addEventListener(AUTH_FAILED_EVENT, hideOnce);

  window.setTimeout(hideOnce, FALLBACK_TIMEOUT_MS);
};

export default initialLoadingPlugin;
